import { Routes } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { AppLayoutComponent } from '@shared/layout/app-layout/app-layout.component';
import { ReviewsComponent } from './pages/reviews/reviews.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { AdminGuard } from '@shared/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: '', redirectTo: 'analysis', pathMatch: 'full'
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'tools',
        loadComponent: () => import('./pages/tools/tools.component').then(m => m.ToolsComponent),
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'analysis',
        loadChildren: () => import('./pages/analysis/analysis.routes').then(m => m.AnalysisRoutes),
        canActivate: [AuthGuard]
      },
      {
        path: 'reviews',
        component: ReviewsComponent,
      },
      {
        path: 'locations',
        loadChildren: () => import('./pages/locations/locations.routes').then(m => m.LocationsRoutes),
        canActivate: [AuthGuard]
      },
      {
        path: 'competitive-analysis',
        loadChildren: () => import('./pages/competitive-analysis/competitive-analysis.routes').then(m => m.CompetitiveAnalysisRoutes),
        canActivate: [AuthGuard]
      },
      {
        path: 'text-analytics',
        loadChildren: () => import('./pages/text-analytics/text-analytics.routes').then(m => m.TextAnalyticsRoutes),
        canActivate: [AuthGuard]
      }
    ]
  },
  // error pages
  {
    path: '**',
    component: NotFoundComponent
  },
];
